<template>
  <div class="container_head">
    <div style="padding: 10px 10px">
      <van-row gutter="10">
        <van-col span="8">
          <div class="item item1" @click="changeview('/user/zhcx')">
            账户查询
          </div>
        </van-col>
        <van-col span="8">
          <div class="item item2" @click="changeview('/common/list/symx')">
            使用明细
          </div>
        </van-col>
        <van-col span="8">
          <div class="item item4" @click="changeview('/user/toupiao')">
            使用投票
          </div>
        </van-col>
        <!-- 				
				<van-col span="8" >
					<div class="item item3" @click="changeview('/user/zjjn')">
						资金缴纳
					</div>
				</van-col> -->
      </van-row>
      <van-row gutter="10" style="margin-top: 10px">
        <van-col span="8">
          <div class="item item5" @click="changeview('/common/list/fags')">
            结果公示
          </div>
        </van-col>
        <van-col span="8">
          <div class="item item3" @click="toPay()">资金缴纳</div>
        </van-col>
        <van-col span="8"> </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  mounted() {
    if (this.$route.query.type != "syx") {
      this.$toast.fail("数据正在迁移中，即将开放");
    }
    // setTimeout(() => {
    // 	this.$router.go(-1)
    // }, 1000);
  },
  methods: {
    changeview(path) {
      if (this.$route.query.type == "syx") {
        this.$router.push(path);
      }
    },
    toPay() {
		var that=this
       this.$axios.get('/hyjg/wxzj/getTicket4Wx?houseId='+sessionStorage.getItem('houseId'),{}).then(res=>{
			if(res.resUrl){
        this.$router.push({path:'/user/zjjn', query: {url:res.resUrl}})
			}else{
				this.$toast.fail("无数据");
			}
		})
    },
  },
};
</script>

<style lang="less" scoped>
.flexcenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.item {
  .flexcenter();
  color: #fff;
  font-size: 16px;
  height: 75px;

  &.item1 {
    background: url("~@img/wxzj/zjcx.png") no-repeat center;
    background-size: 100% 100%;
  }

  &.item2 {
    background: url("~@img/wxzj/symx.png") no-repeat center;
    background-size: 100% 100%;
  }

  &.item3 {
    background: url("~@img/wxzj/zjjn.png") no-repeat center;
    background-size: 100% 100%;
  }
  &.item4 {
    background: url("~@img/wxzj/sytp.png") no-repeat center;
    background-size: 100% 100%;
  }

  &.item5 {
    background: url("~@img/wxzj/jggs.png") no-repeat center;
    background-size: 100% 100%;
  }
}
</style>
